<template>
  <div class="login_container">
    <div class="login_box padding-10">
      <div class="flex">
        <span class="login-text font-1x font-bold margin-r-10" @click="nowActive = 0" :class="{
          active: nowActive === 0
        }">
        登录
      </span>
      <span class="login-text font-1x font-bold margin-r-10" @click="nowActive = 2" :class="{
          active: nowActive === 2
        }">
        扫码登录
      </span>
      <span v-if="0" class="login-text font-1x font-bold" @click="nowActive = 1" :class="{
          active: nowActive === 1
        }">
        修改密码
      </span>
      </div>
      <div v-show="nowActive === 2" style="width: 232px;">
        <iframe class="iframe" :src="wxCode" frameborder="0"></iframe>
      </div>
      <!-- 登录表单区域 -->
      <el-form v-show="nowActive === 0" ref="loginFormRef" :model="loginForm" :rules="loginFormRules" label-width="0px" class="login_form ">
        <!-- 用户名 -->
        <el-form-item prop="username">
          <el-input v-model="loginForm.username" prefix-icon="iconfont icon-yonghu"></el-input>
        </el-form-item>
        <!-- 密码 -->
        <el-form-item prop="password">
          <el-input v-model="loginForm.password" prefix-icon="iconfont icon-mima" type="password"></el-input>
        </el-form-item>
        <!--验证码-->
        <el-form-item prop="code">
          <el-row :gutter="20">
            <el-col :span="16"><el-input v-model="loginForm.code" prefix-icon="iconfont icon-yanzhengma" type="code" @keyup.enter.native="login"></el-input></el-col>
            <el-col :span="8">
              <img @click="getVerificationCode" class="width-100 login-img" :src="codeImg" alt="">
            </el-col>
          </el-row>
        </el-form-item>
        <!-- 按钮区域 -->
        <el-form-item>
          <el-button class="btns" @click="login" type="primary">登录</el-button>
        </el-form-item>
      </el-form>
      <!-- 修改密码表单区域 -->
      <el-form v-show="nowActive === 1" ref="pwdFormRef" :model="pwdForm" :rules="pwdFormRules" label-width="100px" class="login_form ">
        <!-- 用户名 -->
        <el-form-item prop="username" label="用户名">
          <el-input v-model="pwdForm.username"></el-input>
        </el-form-item>
        <el-form-item prop="oldPassword" label="旧密码">
          <el-input v-model="pwdForm.oldPassword" type="password"></el-input>
        </el-form-item>
        <el-form-item prop="newPassword" label="新密码">
          <el-input v-model="pwdForm.newPassword" type="password"></el-input>
          <div class="color-gray font-mini" style="line-height:1.2;">*8-30位大小写字母+数字+特殊字符</div>
        </el-form-item>
        <el-form-item prop="newPassword1" label="确认密码">
          <el-input v-model="pwdForm.newPassword1" type="password"></el-input>
          <div class="color-gray font-mini"  style="line-height:1.2;">*8-30位大小写字母+数字+特殊字符</div>
        </el-form-item>
        <!-- 按钮区域 -->
        <el-form-item>
          <el-button class="btns" @click="updatePwdFn" type="primary">修改密码</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="beian" style="text-align: center;" v-if="showBeian">
      <div>@Copyright 2021-{{year}} Yinger Fashion Group. All Rights Reserved.</div>
      <a style="color: inherit;" target="_blank" href="http://beian.miit.gov.cn">粤ICP备13010952号-1</a>
    </div>
    <div class="beian" style="text-align: center;" v-if="showBeian2">
      <div>@Copyright 2022-{{year}} Yinger Fashion Group. All Rights Reserved.</div>
      <a style="color: inherit;" target="_blank" href="http://beian.miit.gov.cn">粤ICP备20011476号-1</a>
    </div>
  </div>
</template>

<script>
  import { chat_get, chat_post, toForm } from '@/api'
  let dt = new Date()
export default {
  data() {
    var validatePass2 = (rule, value, callback) => {
        if (value === '') {
            callback(new Error('请再次输入密码'));
        } else if (value !== this.pwdForm.newPassword) {
            callback(new Error('两次输入密码不一致!'));
        } else {
            callback();
        }
    };
    return {
      year: dt.getFullYear(),
      // 这是登录表单的数据绑定对象
      loginForm: {
        username: process.env.NODE_ENV === 'development' && 'admin' || '',
        password: process.env.NODE_ENV === 'development' && 'Yradmin123..' || '',
        code: '' // 验证码
      },
      codeImg: '',
      codeId: '',
      // 这是表单的验证规则对象
      loginFormRules: {
        // 验证用户名是否合法
        username: [
          { required: true, message: '请输入登录名称', trigger: 'blur' },
          { min: 3, max: 10, message: '长度在 3 到 10 个字符', trigger: 'blur' }
        ],
        // 验证密码是否合法
        password: [
          { required: true, message: '请输入登录密码', trigger: 'blur' },
          { min: 6, max: 15, message: '长度在 6 到 15 个字符', trigger: 'blur' }
        ],
        code: [
          { required: true, message: '请输入验证码', trigger: 'blur' },
          { min: 1, max: 6, message: '验证码长度不正确', trigger: 'blur' }
        ]
      },
      nowActive: 0,
      pwdForm: {
        username: '',
        oldPassword: '',
        newPassword: '',
        newPassword1: ''
      },
      pwdFormRules: {
        username: [
          { required: true, message: '请输入登录名称', trigger: 'blur' },
          { min: 3, max: 10, message: '长度在 3 到 10 个字符', trigger: 'blur' }
        ],
        oldPassword: [
          { required: true, message: '请输入旧密码', trigger: 'blur' },
          { min: 6, max: 15, message: '长度在 6 到 15 个字符', trigger: 'blur' }
        ],
        newPassword: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { min: 6, max: 15, message: '长度在 6 到 15 个字符', trigger: 'blur' }
        ],
        newPassword1: [
          { required: true, message: '请输入确认密码', trigger: 'blur' },
          { min: 6, max: 15, message: '长度在 6 到 15 个字符', trigger: 'blur' },
          { validator: validatePass2, trigger: 'blur' }
        ]
      },
      wxCode: '',
    }
  },
  created() {
    this.getWxCode();
    this.getVerificationCode();
    if (this.$route.query.code) {
      this.codeLogin(this.$route.query.code)
    }
  },
  methods: {
    codeLogin(code) {
      chat_post('/admin/oauth/login', {
        code
      }, res => {
        if (res.status === 200) {
          console.log(res);
          window.localStorage.setItem('token', res.data.MessageContent.token)
          this.$router.push('/home')
        }
      })
    },
    getWxCode() {
      chat_get('/admin/oauth/url', {}, res => {
        if (res.status === 200) {
          this.wxCode = res.data.MessageContent;
        }
      })
    },
    getVerificationCode() {
      chat_get('/admin/vecode', {}, res => {
        if(res.status == 200) {
          this.codeId =res.data.MessageContent.Id
          this.codeImg =res.data.MessageContent.Img
        }
      })
    },
    login() {
      this.$refs.loginFormRef.validate(valid => {
        if (!valid) return
        let params = {
          username: this.loginForm.username,
          password: this.loginForm.password,
          vcode: this.loginForm.code,
          vid: this.codeId
        }
        chat_post('/admin/auth', params, res => {
         if(res.data.token) {
           window.localStorage.setItem('token', res.data.token)
           this.$router.push('/home')
         }
       },err => {
         this.getVerificationCode();
       })
      })
    },
    updatePwdFn() {
      this.$refs.pwdFormRef.validate(valid => {
        if (!valid) return
        let params = {
          ...this.pwdForm
        }
        chat_post('/admin/updatePwd', params, res => {
          this.$message.success('密码修改成功')
          this.nowActive = 0
        })
      })
    }
  },
  computed: {
    showBeian() {
      return ['www.yingergroup.com', 'www.yingergroup.cn', 'www.hkyinger.com', 'robot.yingerfashion.com', 'localhost:8080'].indexOf(location.host) >= 0
    },
    showBeian2() {
      return ['www.yingermalls.com', 'yingermalls.com'].indexOf(location.host) >= 0
    }
  },
  watch: {
    $route(newValue) {
      if (newValue.query.code) {
        this.codeLogin(newValue.query.code)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.login_container {
  background: url('../assets/images/login-background.png') no-repeat;
  background-position: 0 0;
  background-size: auto 100%;
  height: 100%;
  background-color: #FAFAFA;
}

.login_box {
  min-height: 400px;
  border-radius: 3px;
  position: absolute;
  left: 42%;
  top: 6%;
  background: #FAFAFA;

  .avatar_box {
    height: 130px;
    width: 130px;
    border: 1px solid #eee;
    border-radius: 50%;
    padding: 10px;
    box-shadow: 0 0 10px #ddd;
    position: absolute;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: #fff;
    img {
      width: 100%;
      height: 100%;
      border-radius: 50%;
      background-color: #eee;
    }
  }
}

@media screen and (max-width: 1900px) {
  .login_box {
    right: 10%;
    left: auto;
  }
}
.login-img {
  height: 40px;
}

.login_form {
  margin-top: 80px;
  width: 100%;
  box-sizing: border-box;
}

.btns {
  background-color:#1ED2B5;
  border: none;
  padding: 12px 56px;
  margin-top: 30px;
  width: 100%;
}
  .login-text {
    padding: 10px 26px;
    color: #aaa;
    cursor: pointer;
    &.active {
      border-bottom: 2px solid #1B1929;
      color: #1B1929;
    }
  }
.beian {
  position: fixed;
  left: 805px;
  bottom: 30px;
  color: #666666;
}
.iframe {
  display: block;
  width: 186px;
  height: 292px;
  margin: 32px auto 10px;
}
</style>
